import { IEvent } from '@src/interfaces';
import Classify from '@utils/Classify';
import React from 'react';
import { Form } from 'react-bootstrap';
import ReactInputMask from 'react-input-mask';
import useValidation from '../../Hooks/useValidation';

interface Props {
  required?: boolean,
  name: string,
  title: string,
  value: string,
  setter: (value: string) => void,
  autoFocus?: boolean
}

const Phone: React.FC<Props> = (props) => {

  const { isNotEmpty } = useValidation();

  const isValid = () => {
    return (!props.required && (!isNotEmpty(props.value) || isPhoneNumber(props.value))) || (props.required && isPhoneNumber(props.value));
  }

  const isPhoneNumber = (phone: string): boolean => {
    return phone.length == 10 && phone.replace(/[^0-9]/g, '') == phone;
  }

  return (
    <Form.Group controlId={props.name} className={'form-group ' + Classify.addClassName(!isValid(), 'has-error')}>
      <Form.Label>{props.title}</Form.Label>
      <ReactInputMask
        className={'form-control detail-numeric detail-phone-input' + Classify.addClassName(!isValid(), 'is-invalid')}
        autoComplete='off'
        mask='(999) 999-9999'
        value={props.value ? props.value + '' : ''}
        onChange={(e: IEvent) => {
          props.setter(e.currentTarget.value.replace(/[^0-9]/g, ''));
        }}
      // autoFocus={!!props.autoFocus}
      />
    </Form.Group>
  );
}

export default Phone;